 
import ShowQr from "@/components/showQR/ShowQr.vue";
import HomePage from "@/components/Survay/HomePage.vue";
import SuccessPage from "@/components/Survay/SuccessPage.vue";
import SurveyEndPage from "@/components/Survay/SurveyEndPage.vue";
import SurveyEndStarted from "@/components/Survay/SurveyEndStarted.vue";
import SurveyHome from "@/components/Survay/SurveyHome.vue";
import SurveyStage from "@/components/Survay/SurveyStage.vue";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/", name: "Home", component: HomePage },
  
  { path: "/survey-home", name: "SurveyHome", component: SurveyHome },
  { path: "/survey-stage/:stageNumber", name: "SurveyStage", component: SurveyStage },

  { path: "/show-qr", name: "ShowQR", component: ShowQr },

 
  
  { path: "/stage/:stageNumber/success", name: "SuccessPage", component: SuccessPage },
  { path: "/survey-completed", name: "SurveyEnd", component: SurveyEndPage },
  { path: "/survey-end-progress", name: "SurveyEndProgress", component: SurveyEndStarted },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
